import { atom } from 'recoil';

export const cvParsingResponse = atom({
  key: "cvParsingResponse",
  default: null
});
